import { HttpClient } from '@/shared/lib/http-client';

export const fetchPeriodActsGenerate = async () => {
  const response = await HttpClient.get('/period-acts-generate', {});
  return response.data;
};
